import { getFromApi } from 'actions';
import { profile } from 'constants';

export default resourcePath => getFromApi(`${profile.baseUrl}/${resourcePath}`);
